import type { NodeEntry } from 'slate';

import { renderContentBlockFns } from './content-block';
import { isTOCEntry, Queries } from '../../slate-api';
import type { RenderModelTOC } from '../../slate-api';
import { activeTableOfContentsOutlineColor } from '../colors';
import type { RenderContext } from '../engine/render-context';
import type { BaseRenderNodeOptions } from '../engine/rendering-data';

const TOC_OUTLINE_PADDING = 6;
const TOC_OUTLINE_CORNER_RADIUS = 4;
const UPDATE_TOC_OFFSET = 8;

export function renderTableOfContents(
  renderContext: RenderContext,
  rMTableOfContentsEntry: NodeEntry<RenderModelTOC>,
  options: BaseRenderNodeOptions
) {
  const [, rMTableOfContentsPath] = rMTableOfContentsEntry;
  const { editor, rMSelIntersection } = renderContext;
  const width = Queries.getRMNodeWidthPx(editor, rMTableOfContentsEntry);
  const height = Queries.getRMNodeHeightPx(editor, rMTableOfContentsEntry);

  if (renderContext.isSelectionInsideCMNode()) {
    // Outline
    renderContext.drawRect(
      -TOC_OUTLINE_PADDING,
      -TOC_OUTLINE_PADDING,
      width + TOC_OUTLINE_PADDING * 2,
      height + TOC_OUTLINE_PADDING + 2,
      {
        cornerRadius: TOC_OUTLINE_CORNER_RADIUS,
        stroke: { color: activeTableOfContentsOutlineColor.toString(), thickness: 1 },
      }
    );

    if (rMSelIntersection?.isOriginalFocus) {
      const tableOfContentsEntry = Queries.nodeFromRMLocation(editor, rMTableOfContentsPath);
      if (!isTOCEntry(tableOfContentsEntry)) throw new Error('Expected TOC entry');

      renderContext.renderReactComponent(
        -TOC_OUTLINE_PADDING - UPDATE_TOC_OFFSET,
        -TOC_OUTLINE_PADDING,
        'UpdateTableOfContentsButton',
        { clippable: false, key: `${rMTableOfContentsEntry}-update-button` },
        { tableOfContentsEntry }
      );
    }
  }

  renderContext.renderChildren(rMTableOfContentsEntry, renderContentBlockFns, options);
}
